import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";

import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { AdvertisementProvider } from "../../../context/advertisement/advertisementContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const DoseeAds = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Dosee Ads"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddDoseeAd = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Dosee Ad"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditDoseeAd = () => {
  return (
    <CountryProvider>
      <AdvertisementProvider>
        <DoSeeDataProvider>
          <Auth
            children={
              <Screen
                component={<Edit />}
                title="Edit Dosee Ad"
              />
            }
          />
        </DoSeeDataProvider>
      </AdvertisementProvider>
    </CountryProvider>
  );
};
